var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 864.16 754.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c30c42;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.09,279.63a40.55,40.55,0,0,1-12,28.93,41,41,0,0,1-10.43,7.57,12.73,12.73,0,0,0-7,11.35V620.83a57.46,57.46,0,0,1-57.48,57.44H119.88A57.45,57.45,0,0,1,62.4,620.83V327.46a12.75,12.75,0,0,0-7.08-11.36A40.72,40.72,0,0,1,33,279.56a5.79,5.79,0,0,1,5.84-5.67H238.2A5.85,5.85,0,0,1,244.09,279.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.63,279.63a40.85,40.85,0,0,1-22.39,36.5,12.73,12.73,0,0,0-7.05,11.35v369.2a57.47,57.47,0,0,1-57.48,57.44H413.42a57.46,57.46,0,0,1-57.48-57.44V327.46a12.75,12.75,0,0,0-7.08-11.36,40.72,40.72,0,0,1-22.32-36.54,5.79,5.79,0,0,1,5.84-5.67H531.75A5.84,5.84,0,0,1,537.63,279.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.17,279.63a40.85,40.85,0,0,1-22.39,36.5,12.73,12.73,0,0,0-7,11.35V620.83a57.45,57.45,0,0,1-57.48,57.44H707a57.45,57.45,0,0,1-57.48-57.44V327.46a12.75,12.75,0,0,0-7.08-11.36,40.72,40.72,0,0,1-22.32-36.54,5.79,5.79,0,0,1,5.84-5.67H825.29A5.84,5.84,0,0,1,831.17,279.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.26,220.83l-734,0C28.76,220.86,0,195,0,163v-1.26c0-26.07,18.5-48.92,45.77-56.8l341-98.54a163.91,163.91,0,0,1,90.64,0l341,98.54c27.28,7.89,45.78,30.74,45.77,56.55h0C864.16,194.26,834.65,220.83,798.26,220.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0585e1bdb7b08b637c894e0d6e4eeac5.svg";
export { ForwardRef as ReactComponent };